import { useState } from 'react';

import { css } from '@emotion/css';
import { Col, Row } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { usePositions } from 'src/hooks';
import { LinkText, MButton, MCard, MTable, MTypography, CurrencyField, PercentageField } from 'src/lib';
import { Position } from 'src/models';
import { ColorConstant, Spacing } from 'src/styles';

import { TradeSecurityHoldingModal } from './TradeSecurityHoldingModal';

const tradeButtonStyle = css`
  min-width: 5rem !important;
`;

export const SecurityHoldingsTable = () => {
  const [selectedSecurity, setSelectedSecurity] = useState<Position | null>(null);
  const [isTradeSecurityModalOpen, setIsTradeSecurityModalOpen] = useState(false);

  const { tradablePositionList, isPositionListLoading } = usePositions({
    skip: true,
    skipQuotes: true,
  });

  const cols: ColumnsType<Position> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: value => <LinkText value={value} />,
    },
    {
      title: 'Symbol',
      dataIndex: 'symbol',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: value => (
        <MButton type='primary' onClick={() => onRowClick(value)} className={tradeButtonStyle}>
          Trade
        </MButton>
      ),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
    },
    {
      title: 'Last Price',
      dataIndex: 'value',
      render: (value: number) => <CurrencyField value={value} />,
    },
    {
      title: 'Current Value',
      dataIndex: 'totalValue',
      render: (totalValue: number) => <CurrencyField value={totalValue} />,
    },
    {
      title: '% Change',
      dataIndex: 'change',
      render: (change: number) => (
        <PercentageField value={change} color={change >= 0 ? ColorConstant.GREEN6 : ColorConstant.RED6} />
      ),
    },
  ];

  const onCloseTradeSecurityModal = () => {
    setIsTradeSecurityModalOpen(false);
    setSelectedSecurity(null);
  };

  const onRowClick = (record: Position) => {
    setSelectedSecurity(record);
    setIsTradeSecurityModalOpen(true);
  };

  return (
    <Row>
      <Col span={24} id='securities-section'>
        <Col span={24} className={Spacing.my12}>
          <MTypography variant='h4' weight='semibold' color={ColorConstant.BRAND6}>
            Securities Holdings
          </MTypography>
        </Col>
        <Col span={24}>
          <MCard>
            <MTable
              columns={cols}
              data={tradablePositionList}
              pagination={false}
              loading={isPositionListLoading}
              scroll={{ y: 200 }}
              onRowClick={(record: Position) => onRowClick(record)}
              testId={'securities-holdings-table'}
            />
          </MCard>
        </Col>
      </Col>
      {selectedSecurity && (
        <TradeSecurityHoldingModal
          open={isTradeSecurityModalOpen}
          onClose={onCloseTradeSecurityModal}
          position={selectedSecurity}
        />
      )}
    </Row>
  );
};
